import { Box, Typography, useMediaQuery, Menu, MenuItem } from '@mui/material';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { useHasPermission } from '../../../hooks/useHasPermission';
import ContractRenewStatus from '../contractRenewStatus';
import React, { useState } from 'react';
import { DeleteRecord } from '../../deleteRecord';
import { useTheme } from '@mui/material/styles';
import { useListBackNavigation } from '../../../hooks/listNavigation';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Iconify from '../../Iconify';
import axios from 'axios';
import '../../../css/contracts/contractDetailsHeader.css';

const ContractDetailsHeader = () => {

    const { t } = useTranslation();
    const { goBack, goToList } = useListBackNavigation('/dashboard/contract');
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    const contractDetailsData = useSelector((state) => state.ContractDetailsData);

    const hasContractDeletePermission = useHasPermission('contract_delete');

    const [errMsg, setErrMsg] = useState('');
    const [deleteContract, setDeleteContract] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const openActionMenu = Boolean(anchorEl);

    const handleOpenActionMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseActionMenu = () => {
        setAnchorEl(null);
    };

    const handleGoBack = goBack;

    const handleDeleteContract = async () => {
        try {
            const response = await axios.delete(`contract/${contractDetailsData.id}`);
            if (response.status === 200 || response.status === 201) {
                setDeleteContract(false);
                goToList();
                setErrMsg('');
            }
        } catch (error) {
            setErrMsg(error.message || "Erreur lors de la suppression du contrat");
            console.error('Error updating contract status:', error);
            CustomErrorLogger(error, "Delete Contract");
        }
    }

    return (
        <Box className="ContractDetailsHeader_mainBox">
            <Box className="ContractDetailsHeader_firstPart">
                <Iconify className='ContractDetailsHeader_back_icon' icon="material-symbols:arrow-back" onClick={handleGoBack} />
                <Typography className="ContractDetailsHeader_title">{contractDetailsData?.title}</Typography>
                <ContractRenewStatus status={contractDetailsData?.auto_renew} />
            </Box>
            <Box className="ContractDetailsHeader_secondPart">
                {isDesktop && hasContractDeletePermission &&
                    <Box className="ContractDetailsHeader_action_box" onClick={() => setDeleteContract(true)}>
                        <Iconify className='ContractDetailsHeader_delete_icon' icon="ic:outline-delete" />
                        <Typography className="ContractDetailsHeader_delete_title">{t('Supprimer')}</Typography>
                    </Box>
                }
                {!isDesktop && <Iconify
                    className='ContractDetailsHeader_dots_icon'
                    icon="vaadin:ellipsis-dots-v"
                    id="userPageActionMenuIcom"
                    aria-controls={openActionMenu ? 'long-menu' : undefined}
                    aria-expanded={openActionMenu ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleOpenActionMenu}
                />}
                <Menu
                    id="usersePageActionMenu"
                    MenuListProps="usersPageActionMenuIcom"
                    open={openActionMenu}
                    anchorEl={anchorEl}
                    onClose={handleCloseActionMenu}
                    onClick={handleCloseActionMenu}
                    slotProps={{ paper: { style: { width: '30ch', backgroundColor: '#fffff' } } }}
                >
                    {!isDesktop && hasContractDeletePermission &&
                        <MenuItem className='ContractDetailsHeader_menuItem' onClick={() => setDeleteContract(true)}>
                            <Iconify className='ContractDetailsHeader_delete_icon' icon="ic:outline-delete" />
                            <Typography className="ContractDetailsHeader_delete_title">{t('Supprimer')}</Typography>
                        </MenuItem>
                    }
                </Menu>
            </Box>


            {deleteContract &&
                <DeleteRecord
                    errMsg={errMsg}
                    setErrMsg={setErrMsg}
                    openDelete={deleteContract}
                    setOpenDelete={setDeleteContract}
                    handleDelete={handleDeleteContract}
                    title="Êtes-vous sûr du vouloir supprimer ce contrat ?"
                />
            }
        </Box>
    );
}

export default ContractDetailsHeader;